import { useKeycloak } from '../contexts/KeycloakContext';
import { useCustomer } from '../contexts/CustomerContext';

/**
 * Returns whether the current user can access reports.
 *
 * - Admin / supervisor / sindico / super_admin: always true.
 * - Porteiro / condo_staff / zelador: true only when
 *   selectedCustomer.porteiro_reports_enabled === true.
 */
export function usePorteiroReports(): boolean {
  const { hasAnyRole } = useKeycloak();
  const { selectedCustomer } = useCustomer();

  const isPorteiro = hasAnyRole('porteiro', 'condo_staff', 'zelador');
  if (!isPorteiro) return true;

  return selectedCustomer?.porteiro_reports_enabled === true;
}
